import React, { useState } from 'react';
import user from 'stores/user';
import { formatHashValue } from 'utils';
import { RowBetween } from 'components/Row';
import { TYPE } from 'theme';
import { BRIDGE_URL } from 'constant';
import useTokenBalance from 'hooks/useTokenBalance';
import BigNumber from 'bignumber.js';
import useCapsuleGasFee from 'hooks/useCapsuleGasFee';
import PreMintNFTImg from 'assets/images/home/nft-defalut.png';
import {
    CardContent,
    CardInfoRowWrapper,
    CardButton as BaseCardButton,
    CardFooterLink,
    Tag,
    ArrowWrapper,
} from '../mintNFT/styled';
import { ArrowIcon } from 'components/Icons';
import styled from 'styled-components';
import useMintNFT from 'hooks/useMintNFT';
import { useContract } from 'hooks/useContract';
import { useToast } from 'context/ToastContext';
import { getOnePieceServerApi } from 'gql-ops';
import { observer } from 'mobx-react';
import Tooltip from 'components/TooltipInfo';
import missionStore from 'stores/missionStore';

const CardButton = styled(BaseCardButton)<{ $isSuccess?: boolean }>`
    ${({ $isSuccess }) =>
        $isSuccess &&
        `
        background: #0c150b !important;
        background-image: none !important;
        border: 1px solid #5FD15C !important;
        color: #5FD15C !important;
    `}
`;

const CheckCircle = styled.div<{ active?: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${({ active }) => (active ? '#5FD15C' : '#585858')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 8px;

    svg {
        width: 14px;
        height: 14px;
    }
`;

const CheckIcon = () => (
    <svg width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 2L3 5.5L1.5 4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const NFT_ABI = [
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_startTime',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'ERC721EnumerableForbiddenBatchMint',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'ERC721IncorrectOwner',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'ERC721InsufficientApproval',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'approver',
                type: 'address',
            },
        ],
        name: 'ERC721InvalidApprover',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'ERC721InvalidOperator',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'ERC721InvalidOwner',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'receiver',
                type: 'address',
            },
        ],
        name: 'ERC721InvalidReceiver',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'ERC721InvalidSender',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'ERC721NonexistentToken',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'ERC721OutOfBoundsIndex',
        type: 'error',
    },
    {
        inputs: [],
        name: 'InvalidInitialization',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NotInitializing',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'OwnableInvalidOwner',
        type: 'error',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'OwnableUnauthorizedAccount',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'approved',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'startTokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'BatchMint',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint64',
                name: 'version',
                type: 'uint64',
            },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'user',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Mint',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [],
        name: 'WithdrawFunds',
        type: 'event',
    },
    {
        inputs: [],
        name: 'MINT_TIME_PERIOD',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
        ],
        name: 'adminMint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'getApproved',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getNextTokenId',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'hasMinted',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_owner',
                type: 'address',
            },
            {
                internalType: 'string',
                name: '_name',
                type: 'string',
            },
            {
                internalType: 'string',
                name: '_symbol',
                type: 'string',
            },
            {
                internalType: 'string',
                name: '_uri',
                type: 'string',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'isApprovedForAll',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'mint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'ownerOf',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'startTime',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'tokenByIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'tokenOfOwnerByIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'tokenURI',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
] as const;

const CardInfo = styled.div`
    position: relative;
    width: 100%;
    max-width: 360px;
    background: linear-gradient(180deg, #6a0dad4d 0%, #000000 100%);
    border-radius: 24px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(50px);
    border: 1px solid ${({ theme }) => theme.c.bg02};
`;

const ImageContainer = styled.div`
    width: 80%;
    padding: 0 12px;
    img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }
`;

const TruncatedText = styled.span`
    cursor: help;
`;

interface MintError extends Error {
    message: string;
    code?: string;
}

function MintNFTOperateCard({ mission, onChange }: { mission?: any; onChange?: (mission?: any) => void }) {
    const [isMintSuccess, setIsMintSuccess] = useState(false);
    const { balance } = useTokenBalance('0x');
    const [gasFee, isGasFeeLoaded] = useCapsuleGasFee();
    const toast = useToast();

    const contract = useContract(mission?.meta?.tokenAddress, NFT_ABI);

    const { mint } = useMintNFT({
        contract,
        onSuccess: async (mission) => {
            setIsMintSuccess(true);
            try {
                const updatedMission = missionStore.missions.find((m) => m.id === mission.id);
                if (updatedMission?.meta?.historyId) {
                    await getOnePieceServerApi().syncMissionStatus({
                        address: user.address,
                        historyId: updatedMission.meta.historyId,
                    });
                }
                if (onChange) {
                    onChange(updatedMission);
                }
            } catch (error) {
                console.error('Failed to syncMissionStatus:', error);
            }
        },
    });

    function ifGasEnough() {
        return new BigNumber(gasFee).multipliedBy(1.3).lte(balance);
    }

    const handleMint = async () => {
        if (!user.address) {
            toast('Please connect your wallet first', 'error');
            return;
        }

        if (mission && contract) {
            try {
                const startTime = Number(await contract.startTime());
                const mintTimePeriod = Number(await contract.MINT_TIME_PERIOD());
                const currentTime = Math.floor(Date.now() / 1000);

                if (currentTime < startTime) {
                    const startDate = new Date(startTime * 1000).toLocaleString();
                    toast(`Minting has not started yet. Start time: ${startDate}`, 'error');
                    return;
                }

                if (currentTime > startTime + mintTimePeriod) {
                    const endDate = new Date((startTime + mintTimePeriod) * 1000).toLocaleString();
                    toast(`Minting has ended. End time: ${endDate}`, 'error');
                    return;
                }

                await mint(mission);
            } catch (error) {
                console.error('Minting failed:', error);
                const mintError = error as MintError;
                if (mintError.message?.includes('transaction underpriced')) {
                    toast('Gas fee too low, please try again later', 'error');
                } else if (mintError.message?.includes('user rejected')) {
                    toast('Transaction cancelled by user', 'error');
                } else {
                    toast('Minting failed, please try again later', 'error');
                }
            }
        }
    };

    const isGasEnough = ifGasEnough();
    const isLoadingGas = !isGasFeeLoaded;

    return (
        <CardInfo>
            <ImageContainer>
                <img src={mission?.meta?.tokenImageUrl || PreMintNFTImg} alt="" />
            </ImageContainer>
            <CardContent>
                <>
                    <CardInfoRowWrapper>
                        <RowBetween>
                            <TYPE.main fontSize={14} mobileFz={14} fontWeight={500}>
                                {(mission?.meta?.tokenName?.length > 20 ? (
                                    <Tooltip title={mission?.meta?.tokenName}>
                                        <TruncatedText>{`${mission?.meta?.tokenName?.slice(0, 20)}...`}</TruncatedText>
                                    </Tooltip>
                                ) : (
                                    mission?.meta?.tokenName
                                )) || ''}
                            </TYPE.main>
                            <TYPE.main fontSize={14} mobileFz={14} fontWeight={500}>
                                {mission?.status === 'Completed' ? (
                                    <Tag># {Number(mission?.meta?.tokenId) || ''}</Tag>
                                ) : null}
                            </TYPE.main>
                        </RowBetween>
                        {mission?.status === 'Completed' ? null : (
                            <>
                                <RowBetween>
                                    <TYPE.desc fontSize={12} mobileFz={12} opacity={0.6}>
                                        Minted to Address
                                    </TYPE.desc>
                                    <TYPE.main fontSize={14} mobileFz={14} fontWeight={500}>
                                        {formatHashValue(user.address || '')}
                                    </TYPE.main>
                                </RowBetween>
                                <RowBetween>
                                    <TYPE.desc fontSize={12} mobileFz={12} opacity={0.6}>
                                        Mint Amount
                                    </TYPE.desc>
                                    <TYPE.main fontSize={14} mobileFz={14} fontWeight={500}>
                                        {isMintSuccess ? '1' : '0'}/1
                                    </TYPE.main>
                                </RowBetween>
                            </>
                        )}
                    </CardInfoRowWrapper>
                    <CardButton
                        type="gradient"
                        onClick={handleMint}
                        disabled={!isGasEnough || isLoadingGas}
                        loading={isLoadingGas}
                        $isSuccess={isMintSuccess}
                    >
                        {isMintSuccess && (
                            <CheckCircle active color="#fff">
                                <CheckIcon />
                            </CheckCircle>
                        )}
                        {isMintSuccess ? 'SUCCESS' : isGasEnough ? 'CONFIRM' : 'No Enough Gas'}
                    </CardButton>
                    <CardFooterLink href={BRIDGE_URL} target="_blank" rel="noopener noreferrer">
                        <strong>Bridge</strong>&nbsp;more BTC to GOAT Network{' '}
                        <ArrowWrapper>
                            <ArrowIcon />
                        </ArrowWrapper>
                    </CardFooterLink>
                </>
            </CardContent>
        </CardInfo>
    );
}

export default observer(MintNFTOperateCard);
